module.exports = __webpack_public_path__ + "static/media/step_009.4d214c13.jpeg";